import React from "react";
import tw, { styled } from "twin.macro";

import Logo, { LogoColor } from "./partials/Logo";

interface HeaderLogoProps {
  color?: LogoColor;
}

const LogoWrapper = styled.div`
  ${tw`mr-auto my-0`}

  display: flex;
  height: 34px;
  z-index: 40;
`;

const HeaderLogo: React.FunctionComponent<HeaderLogoProps> = ({
  color = LogoColor.Default,
}) => (
  <LogoWrapper className="logo">
    <Logo color={color} />
  </LogoWrapper>
);

export default HeaderLogo;
